<template>
  <div class="documents-list">
    <p v-if="documents.length == 0" class="font-weight-thin ml-2" v-translate>No documents.</p>
    <v-list v-else flat>
			<DocumentItem 
				v-for="document in documents"
				:document="document"
				:key="document.id"
				:disabled="disabled"
				@delete-document="deleteDocument" />
		</v-list>
  </div>
</template>

<script>
import DocumentItem from "@/components/appointment/anamnesis/DocumentItem.vue";

export default {
  name: "DocumentsList",
	props: ["documents", "disabled"],
	components: {
		DocumentItem
	},
  data: () => ({}),
  methods: {
		deleteDocument(document) {
			this.documents.splice(this.documents.indexOf(document), 1);
    }
  }
}
</script>